import { Action, createPropertySelectors, Selector, SelectorOptions, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';

import { StateSliceName } from '../store.models';

import { IApplication, IApplicationStateModel } from './application.model';
import { applicationStateDefaults } from './application.utils';
import { FetchApplicationData, SetSelectedApplicationId } from './application.actions';
import { ApplicationService } from './application.service';

@SelectorOptions({ injectContainerState: false })
@State<IApplicationStateModel>({
    name: StateSliceName.APPLICATION,
    defaults: applicationStateDefaults,
})
@Injectable()
export class ApplicationState {
    private readonly _applicationService = inject(ApplicationService);
    public static selectors = createPropertySelectors<IApplicationStateModel>(ApplicationState);

    @Selector([
        ApplicationState.selectors.applications,
        ApplicationState.selectors.selectedApplicationId
    ])
    public static selectedApplicationId(
        applications: IApplication[] | undefined,
        selectedApplicationId: string | undefined
    ): string | undefined {
        if (!applications ) {
            return;
        }

        return applications.find((application) => application.id === selectedApplicationId)?.id;
    }

    @Action(FetchApplicationData)
    private _fetchApplicationData({ patchState }: StateContext<IApplicationStateModel>) {
        return this._applicationService.getApplicationData().pipe(
            map((applications) => {
                return patchState({
                    applications
                });
            })
        );
    }

    @Action(SetSelectedApplicationId)
    private _setSelectedApplicationId({ patchState }: StateContext<IApplicationStateModel>, { applicationId }: SetSelectedApplicationId) {
        return patchState({
            selectedApplicationId: applicationId
        });
    }
}
